module.exports = __webpack_public_path__ + "img/Taurus.5e9e52d4.svg";